var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorToast',{attrs:{"id":_vm.toastId,"error-message":_vm.$t('unhandled-error-messager.message'),"title":_vm.$t('unhandled-error-messager.title')}})
}
var staticRenderFns = []

export { render, staticRenderFns }